import classes from './NoResults.module.scss';

const NoResults = ({ isMobile = false, icon, primaryTxt, secondaryTxt, children }) => {
  return (
    <section className={classes.mainContainer}>
      {icon}
      <p className={classes.primaryTxt}>{primaryTxt}</p>
      <p className={classes.secondaryTxt}>{secondaryTxt}</p>
      <div className={isMobile ? classes.childrenContainer : classes.baseChildrenContainer}>{children}</div>
    </section>
  );
};

export default NoResults;
